import { useMemo } from "react";
import { useMediaQuery } from "./useMediaQuery";

export enum MediaQueryKind {
	Mobile = 0,
	MobileXl = 1,
	MobileL = 2,
	MobileM = 3,
	MobileS = 4,
	MobileXs = 5,
	Responsive = 6,
	CompactTablet = 7
}

const kindToCssVariable: { [key in MediaQueryKind]: string } = {
	[MediaQueryKind.Mobile]: "--mobile-query-selector",
	[MediaQueryKind.MobileXl]: "--mobile-xl-query-selector",
	[MediaQueryKind.MobileL]: "--mobile-l-query-selector",
	[MediaQueryKind.MobileM]: "--mobile-m-query-selector",
	[MediaQueryKind.MobileS]: "--mobile-s-query-selector",
	[MediaQueryKind.MobileXs]: "--mobile-xs-query-selector",
	[MediaQueryKind.Responsive]: "--responsive-selector",
	[MediaQueryKind.CompactTablet]: "--compact-tablet-selector"
};

export function useWorkspaceMediaQuery(kind: MediaQueryKind): boolean {
	const mediaQuery: string = useMemo(
		(): string => {
			return getComputedStyle(document.documentElement)
				.getPropertyValue(kindToCssVariable[kind]);
		},
		[kind]
	);

	return useMediaQuery(mediaQuery);
}